import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environmentprod';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class Api {
  private bookingSuccessSource = new BehaviorSubject<boolean>(false);
  public closeslotModel = new BehaviorSubject<boolean>(false)

  bookingSuccess$ = this.bookingSuccessSource.asObservable();
  closemod$ = this.closeslotModel.asObservable()

  emitBookingSuccess(status: boolean) {
    this.bookingSuccessSource.next(status);
  }




  private extBaseUrl = environment.extApi;

  constructor(
    private http: HttpClient,
    private toastr: ToastrService
  ) { }


  // Get school data by ID
  getSchoolData(schoolId: any) {
    return this.http.get(
      `${this.extBaseUrl}schoolLogin/get-one-open-record/?schoolId=${schoolId}&isActive=true`
    );
  }

  // Get all sections for a school
  getAllSectionList(schoolId: string, hostUrl: string) {
    return this.http.get(hostUrl + 'auth/section-list/' + schoolId);
  }

  // Display toast notifications
  displayToast(message: string, code: number) {
    if (code === 200) {
      this.toastr.success(message);
    } else if (code === 500) {
      this.toastr.error(message);
    } else {
      this.toastr.info(message);
    }
  }
  public getTeacherList(schoolId: string): Observable<any> {
    return this.http.get<any>(
      `${this.extBaseUrl}principal/getAllTeachersWithClasses/${schoolId}`
    );
  }
  public getTeacherByPrinciple(
    schoolid: any,
    sessionid: any,
    usertype: any,
    usertypeTeacher: any,
    userTypeCordinator: any,
    hostUrl: any,
    lectureID: any,
  ): Observable<any> {
    let params = new HttpParams()
    if (usertypeTeacher === 'TEACHER') {
      params = params.append('schoolId', schoolid)
      params = params.append('lectureId', lectureID)
      params = params.append('sessionId', sessionid)
      params = params.append('userType', usertype)
      params = params.append('hostUrl', hostUrl);
    }
    else {
      params = params.append('schoolId', schoolid)
      params = params.append('sessionId', sessionid)
      params = params.append('userType', usertype)
      params = params.append('hostUrl', hostUrl);
    }


    // Add only if valid
    if (usertypeTeacher) {
      params = params.append('userType', usertypeTeacher);
    }
    if (userTypeCordinator) {
      params = params.append('userType', userTypeCordinator);
    }
    return this.http.get<any>(
      `${this.extBaseUrl}training/get-trainee`,
      { params }
    );
  }
  public getTeacherByIndividual(schoolid: any, sessionid: any, usertype: any, usertypeTeacher: any, hostUrl: any): Observable<any> {

    return this.http.get<any>(
      `${this.extBaseUrl}training/get-trainee?schoolId=${schoolid}&sessionId=${sessionid}&userId=${usertype}&hostUrl=${hostUrl}`
    );
  }
  getavailablesessions(data: any, schoolid: any) {
    return this.http.get(this.extBaseUrl + `training/get-available-sessions?lectureId=${data}&schoolId=${schoolid}`)
  }
  Enquiry(data: any) {
    return this.http.post(this.extBaseUrl + 'auth/enquirySubmitions', data)
  }
  sendmessage(body: any) {
    return this.http.post('https://test-api.kaboodle.in/api/whatsapp/send-booking-message', body)
  }
  updateRecord(id: any) {
    const body = { bookingStatus: 'attended' };

    return this.http.patch(
      this.extBaseUrl + `sessionBookings/update-record?bookingId=${id}`,
      body
    );
  }
  updateSessionFeedback(
    phoneNumber: string,
    sessionId: string,
    rating: number,
    remarks: string
  ) {
    const url = `${this.extBaseUrl}training/update-feedback?phoneNumber=${phoneNumber}&sessionId=${sessionId}`;

    const body = {
      rating,
      remarks
    };

    return this.http.patch(url, body);
  }
  getCourseList() {
    return this.http.get(this.extBaseUrl + 'training/get-all-course')
  }

  getCourseDetails(data: any) {
    return this.http.get(this.extBaseUrl + 'training/get-course-details', { params: data })
  }
  deleteBookedSession(bookingId: any) {
    return this.http.delete(
      `${this.extBaseUrl}sessionBookings/delete-record?bookingId=${bookingId}`
    );
  }
  getQuestions(data: any) {
    return this.http.get(this.extBaseUrl + 'training/get-questions', { params: data })
  }

  saveAnswer(data: any) {
    return this.http.post(this.extBaseUrl + 'training/saveVideoAnswer', data)
  }

  saveBookedslot(data: any) {
    return this.http.post(this.extBaseUrl + 'training/book-session', data)
  }

  getFeedbacksOfLecture(data: any) {
    return this.http.get(this.extBaseUrl + 'training/get-feedbacks', { params: data })
  }

  trigeerclosemod(flag: any) {
    this.closeslotModel.next(flag)
  }
}
